import { rem } from 'polished';
import React from 'react';
import styled from 'styled-components';

import { LoaderCircular } from '@vimeo/iris/motion';

const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: ${rem(100)};
`;

const LoadingPage = () => (
  <Wrapper>
    <LoaderCircular size="xl" />
  </Wrapper>
);

export default LoadingPage;
